// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
  padding: 20px;
}

.auth-container {
  background: white;
  border-radius: 16px;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.auth-header {
  text-align: center;
  margin-bottom: 32px;
}

.auth-logo {
  font-size: 48px;
  display: block;
  margin-bottom: 16px;
}

.auth-header h1 {
  font-size: 24px;
  color: var(--text);
  margin: 0 0 8px 0;
}

.auth-header p {
  color: var(--text-light);
  margin: 0;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text);
}

.form-group input {
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

.form-group input.valid {
  border-color: var(--success);
}

.form-group input.invalid {
  border-color: var(--error);
}

.form-group small {
  font-size: 12px;
  color: var(--text-light);
}

.input-with-status {
  position: relative;
}

.input-with-status input {
  width: 100%;
  padding-right: 40px;
}

.status-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}

.status-icon.valid {
  color: var(--success);
}

.status-icon.invalid {
  color: var(--error);
}

.auth-error {
  background: #ffebee;
  color: var(--error);
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}

.auth-button {
  background: var(--primary);
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.auth-button:hover:not(:disabled) {
  background: var(--primary-dark);
}

.auth-button:active:not(:disabled) {
  transform: scale(0.98);
}

.auth-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.auth-footer {
  text-align: center;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #eee;
}

.auth-footer p {
  color: var(--text-light);
  margin: 0;
}

.auth-footer a {
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
}

.auth-footer a:hover {
  text-decoration: underline;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Auth.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6EAA6E;EAC7E,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);\n  padding: 20px;\n}\n\n.auth-container {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.auth-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.auth-logo {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 16px;\n}\n\n.auth-header h1 {\n  font-size: 24px;\n  color: var(--text);\n  margin: 0 0 8px 0;\n}\n\n.auth-header p {\n  color: var(--text-light);\n  margin: 0;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.form-group input {\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);\n}\n\n.form-group input.valid {\n  border-color: var(--success);\n}\n\n.form-group input.invalid {\n  border-color: var(--error);\n}\n\n.form-group small {\n  font-size: 12px;\n  color: var(--text-light);\n}\n\n.input-with-status {\n  position: relative;\n}\n\n.input-with-status input {\n  width: 100%;\n  padding-right: 40px;\n}\n\n.status-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n}\n\n.status-icon.valid {\n  color: var(--success);\n}\n\n.status-icon.invalid {\n  color: var(--error);\n}\n\n.auth-error {\n  background: #ffebee;\n  color: var(--error);\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.auth-button {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 14px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.1s;\n}\n\n.auth-button:hover:not(:disabled) {\n  background: var(--primary-dark);\n}\n\n.auth-button:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.auth-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.auth-footer {\n  text-align: center;\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid #eee;\n}\n\n.auth-footer p {\n  color: var(--text-light);\n  margin: 0;\n}\n\n.auth-footer a {\n  color: var(--primary);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.auth-footer a:hover {\n  text-decoration: underline;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
